import { put, takeLatest } from "redux-saga/effects";
import { getJwt } from '../../../crud/auth.crud';
import { postRequestWrapper } from '../../../utils/fetch';
import { normalizeAndValidateAsin } from '../../../utils/asins';
import { notify } from 'app/Services/app/notificationService/notify';
import { actions as authActions } from "../auth/actions";
import { actionTypes } from "./actionTypes";
import { actions } from './actions';

export function* watchAsinAnalysisSaga() {
    yield takeLatest(actionTypes.FetchAsinAnalysis, apiFetchAsinAnalysisSaga);
    yield takeLatest(actionTypes.FetchSuggestedKeywords, apiFetchSuggestedKeywordsSaga);
}

function* apiFetchAsinAnalysisSaga(action) {
    yield put(authActions.disableSendButtonState());
    const token = yield getJwt();
    const { asin, valid } = normalizeAndValidateAsin(action.payload.ASIN);
    if (!valid) {
      notify.error('Invalid ASIN. Please enter a 10-character alphanumeric ASIN.');
      yield put(authActions.disableSendButtonState(false));
      return;
    }
    const requestPayload = {
      ASIN: asin,
      useNew: action.payload.useNew
    };
    const apiRes = yield postRequestWrapper("/asin-analysis", token, requestPayload);
    if (apiRes) {
      yield put(actions.updateAsinAnalysis(apiRes));
    }
    yield put(authActions.disableSendButtonState(false));
}

function* apiFetchSuggestedKeywordsSaga(action) {
    yield put(authActions.disableSendButtonState());
    const token = yield getJwt();
    const { asin, valid } = normalizeAndValidateAsin(action.payload.ASIN);
    if (!valid) {
      notify.error('Invalid ASIN. Please enter a 10-character alphanumeric ASIN.');
      yield put(authActions.disableSendButtonState(false));
      return;
    }
    const requestPayload = {
      ASIN: asin,
    };
    const apiRes = yield postRequestWrapper("/suggested-keywords", token, requestPayload);
    if (apiRes) {
      yield put(actions.updateSuggestedKeywords(apiRes));
    }
    yield put(authActions.disableSendButtonState(false));
}